<style src='@/resources/styles/terms.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <h1 class='lead'>Privacy Policy</h1>
      <div class='terms-text-wrapper'>
          <div class='terms-text'>
              <div class='tos'>
                  Effective date: 23/01/2020
              </div>
              <!-- 1 -->
              <div class='tos'>
                  <h2 class='heading'><u>1. Introduction</u></h2>
                  Welcome to <strong>Criminull Inc.</strong>

                  Criminull Inc. (“us”, “we”, or “our”) operates <a href="https://naminus.com">https://naminus.com</a>
                  (hereinafter referred to as “<strong>Service</strong>”). <br /> <br />

                  Our Privacy Policy governs your visit to <a href="https://naminus.com">https://naminus.com</a>, and explains how we collect, safeguard and disclose information that results from your use of our Service.
                  <br /><br />

                  We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
                  <br /><br />

                  Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“agreement”).


              </div>

              <!-- 2 -->
              <div class='tos'>
                  <h2 class='heading'><u>2. Definitions</u></h2>
                  <strong>SERVICE</strong> means the <a href="https://naminus.com">https://naminus.com</a> website operated by Criminull Inc.
                  <br /><br />

                  <strong>PERSONAL DATA</strong> means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).
                  <br /><br />

                  <strong>USAGE DATA</strong> is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).
                  <br /><br />

                  <strong>COOKIES</strong> are small files stored on your device (computer or mobile device).
                  <br /><br />

                  <strong>DATA CONTROLLER</strong> means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.
                  <br /><br />

                  <strong>DATA PROCESSORS (OR SERVICE PROVIDERS)</strong> means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.
                  <br /><br />

                  <strong>DATA SUBJECT</strong> is any living individual who is the subject of Personal Data.
                  <br /><br />

                  <strong>THE USER</strong> is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.

              </div>
              <!-- 3 -->
              <div class='tos'>
                  <h2 class='heading'><u>3. Information Collection and Use</u></h2>
                  We collect several different types of information for various purposes to provide and improve our Service to you.
              </div>
              <!-- 4 -->
              <div class='tos'>

                  <h2 class='heading'><u>4. Types of Data Collected</u></h2>
                  <h3><strong>Personal Data</strong></h3>
                  While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“<strong>Personal Data</strong>”). Personally identifiable information may include, but is not limited to:
                  <br /><br />
                  (a) Email address
                  <br /><br />
                  (b) First name and last name
                  <br /><br />
                  (c) Cookies and Usage Data
                  <br /><br />
                  We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at <a href="mailto:hi@naminus.com" target="_top">hi@naminus.com</a>.
                  <br /><br />


                  <h3><strong>Usage Data</strong></h3>
                  We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (“<strong>Usage Data</strong>”).
                  <br /><br />
                  This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                  <br /><br />
                  When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
                  <br /><br />


                  <h3><strong>Tracking Cookies Data</strong></h3>
                  We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.
                  <br /><br />
                  Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.
                  <br /><br />
                  You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                  <br /><br />
                  Examples of Cookies we use:
                  <br /><br />
                  <strong>(a) Session Cookies:</strong> We use Session Cookies to operate our Service.
                  <br /><br />
                  <strong>(b) Preference Cookies:</strong> We use Preference Cookies to remember your preferences and various settings.
                  <br /><br />
                  <strong>(c) Security Cookies:</strong> We use Security Cookies for security purposes.
                  <br /><br />
                  <strong>(d) Advertising Cookies:</strong> Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.
                  <br /><br />


                  <h3><strong>Other Data</strong></h3>
                  While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, registration at place of residence and actual address, telephone number (work, mobile), details of documents on education, qualification, professional training, employment agreements, non-disclosure agreements, information on bonuses and compensation, information on marital status, family members, social security (or other taxpayer identification) number, office location and other data.
              </div>


              <!-- 5 -->
              <div class='tos'>
                  <h2 class='heading'><u>5. Use of Data</u></h2>
                  Criminull Inc. uses the collected data for various purposes:
                  <br /><br />
                  (a) to provide and maintain our Service;
                  <br /><br />
                  (b) to notify you about changes to our Service; 
                  <br /><br />
                  (c) to allow you to participate in interactive features of our Service when you choose to do so; 
                  <br /><br />
                  (d) to provide customer support; 
                  <br /><br />
                  (e) to gather analysis or valuable information so that we can improve our Service; 
                  <br /><br />
                  (f) to monitor the usage of our Service;
                  <br /><br />
                  (g) to detect, prevent and address technical issues;
                  <br /><br />
                  (h) to fulfill any other purpose for which you provide it;
                  <br /><br />
                  (i) to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;
                  <br /><br />
                  (j) to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;
                  <br /><br />
                  (k) to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;
                  <br /><br />
                  (l) in any other way we may describe when you provide the information;
                  <br /><br />
                  (m) for any other purpose with your consent. 

              </div>
              <!-- 6 -->
              <div class='tos'>
                  <h2 class='heading'><u>6. Retention of Data</u></h2>
                  We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
                  <br /><br />
                  We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.

              </div>
              <!-- 7 -->

              <div class='tos'>
                  <h2 class='heading'><u>7. Transfer of Data</u></h2>
                  Your information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
                  <br /><br />
                  If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
                  <br /><br />
                  Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
                  <br /><br />
                  Criminull Inc. will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.

              </div>

              <!-- 8 -->

              <div class='tos'>
                  <h2 class='heading'><u>8. Disclosure of Data</u></h2>
                  We may disclose personal information that we collect, or you provide:
                  <br /><br />
                  (a)  <strong>Disclosure for Law Enforcement.</strong>
                      Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.
                  
                  <br /><br />
                  (b) <strong>Business Transaction.</strong>
                      If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.
                  
                  <br /><br />
                  (c) <strong>Other cases. We may disclose your information also:</strong>
                      <br /><br />
                      
                          (i) to our subsidiaries and affiliates;
                          <br /><br />
                          (ii)  to contractors, service providers, and other third parties we use to support our business;
                          <br /><br />

                          (iii) to fulfill the purpose for which you provide it;
                          <br /><br />

                          (iv)  for any other purpose disclosed by us when you provide the information;
                          <br /><br />

                          (v) with your consent in any other cases;
                          <br /><br />

                          (vi)  if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others.
                      
                  

              </div>
              <!-- 9 -->
              <div class='tos'>
                  <h2 class='heading'><u>9. Security of Data</u></h2>
                  The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
              </div>

              <!-- 10 -->
              <div class='tos'>
                  <h2 class='heading'><u>10. Your Data Protection Rights Under General Data Protection Regulation (GDPR)</u></h2>
                  If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR. – See more at <a href="https://eur-lex.europa.eu/eli/reg/2016/679/oj">https://eur-lex.europa.eu/eli/reg/2016/679/oj</a>
                  <br/><br/>
                  We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
                  <br/><br/>
                  If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at <a href="mailto:hi@naminus.com" target="_top">hi@naminus.com</a>.
                  <br/><br/>
                  In certain circumstances, you have the following data protection rights:
                  <br/><br/>
                  (a) the right to access, update or to delete the information we have on you;
                  <br/><br/>
                  (b) the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;
                  <br/><br/>
                  (c) the right to object. You have the right to object to our processing of your Personal Data;
                  <br/><br/>
                  (d) the right of restriction. You have the right to request that we restrict the processing of your personal information;
                  <br/><br/>
                  (e) the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;
                  <br/><br/>
                  (f) the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;
                  <br/><br/>
                  Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.
                  <br/><br/>
                  You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).

              </div>
              <!-- 11 -->
              <div class='tos'>
                  <h2 class='heading'><u>11. Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)</u></h2>
                  CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy. – See more at: <a href="https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/">https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/ </a>
                  <br/><br/>
                  According to CalOPPA we agree to the following:
                  <br/><br/>
                  (a) users can visit our site anonymously;
                  <br/><br/>
                  (b) our Privacy Policy link includes the word “Privacy”, and can easily be found on the page specified above on the home page of our website;
                  <br/><br/>
                  (c) users will be notified of any privacy policy changes on our Privacy Policy Page;
                  <br/><br/>
                  (d) users are able to change their personal information by emailing us at <a href="mailto:hi@naminus.com" target="_top">hi@naminus.com.</a>
                  <br/><br/>
                  Our Policy on “Do Not Track” Signals:
                  <br/><br/>
                  We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.
                  <br/><br/>

                  You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.

              </div>
              <!-- 12 -->
              <div class='tos'>
                  <h2 class='heading'><u>12. Service Providers</u></h2>
                  We may employ third party companies and individuals to facilitate our Service (“<strong>Service Providers</strong>”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
                  <br/><br/>
                  These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.

              </div>
              <!-- 13 -->
              <div class='tos'>
                  <h2 class='heading'><u>13.  Analytics</u></h2>
                  We may use third-party Service Providers to monitor and analyze the use of our Service.
                  <br/><br/>
                  <h3><strong>Google Analytics</strong></h3>
                  Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.
                  <br/><br/>
                  For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
                  <br/><br/>
                  We also encourage you to review the Google's policy for safeguarding your data: <a href="https://support.google.com/analytics/answer/6004245">https://support.google.com/analytics/answer/6004245</a>.

                  <br/><br/>
                  <h3><strong>Mixpanel</strong></h3>
                  Mixpanel is provided by Mixpanel Inc.
                  <br/><br/>
                  You can prevent Mixpanel from using your information for analytics purposes by opting-out. To opt-out of Mixpanel service, please visit this page: <a href="https://mixpanel.com/optout/">https://mixpanel.com/optout/</a>
                  <br/><br/>
                  For more information on what type of information Mixpanel collects, please visit the Terms of Use page of Mixpanel:  <a href="https://mixpanel.com/terms/">https://mixpanel.com/terms/</a>.

                  <br/><br/>
                  <h3><strong>Amplitude</strong></h3>
                  Amplitude is provided by Amplitude, Inc.
                  <br/><br/>
                  For more information on what type of information Amplitude collects, please visit the Amplitude
                  Privacy Policy page: <a href="https://amplitude.com/privacy">https://amplitude.com/privacy</a> and Amplitude Terms of
                  Service page: <a href="https://amplitude.com/terms">https://amplitude.com/terms</a>.



                  <br/><br/>
                  <h3><strong>Hotjar</strong></h3>
                  Hotjar is provided by Hotjar Ltd.
                  <br/><br/>
                  You can prevent HotJar from using your information for analytics purposes by opting-out. To opt-out
                  of Hotjar service, please visit this page: <a href="https://www.hotjar.com/legal/compliance/opt-out/">https://www.hotjar.com/legal/compliance/opt-out</a>

                  <br/><br/>
                  For more information on what type of information Hotjar collects, please visit the Privacy Policy
                  page of Hotjar: <a href="https://www.hotjar.com/legal/policies/privacy">https://www.hotjar .com/legal/policies/privacy</a>
                  and the Terms of Service page of Hotjar: <a href="https://www.hotjar.com/legal/policies/terms-of-service">https://www.hotjar.com/legal/policies/terms-of-service</a>.



                  <br/><br/>
                  <h3><strong>Segment</strong></h3>
                  Segment is provided by Segment.io, Inc.
                  <br/><br/>
                  For more information on what type of information Segment collects,, please visit the Segment Privacy
                  Policy page: <a href="https://segment.com/docs/legal/privacy/">https://segment.com/docs/legal/privacy/</a> and
                  Segment Terms of Service page: <a href="https://segment.com/docs/legal/">https://segment.com/docs/legal/</a>.

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>14.  Customer Support</u></h2>
                  We may use third-party Service Providers to provide live chat and customer support.
                  <br/><br/>
                  <h3><strong>Zendesk</strong></h3>
                  Zendesk is provided by Zendesk, Inc.
                  <br/><br/>
                  For more information on what type of information Zendesk collects, please visit the Zendesk Privacy
                  Policy page: <a href="https://www.zendesk.com/company/customers-partners/privacy-policy/">https://www.zendesk.com/company/customers-partners/privacy-policy</a>
                  and Zendesk Terms of Use page: <a href="https://www.zendesk.com/company/customers-partners/terms-of-use/">https://www.zendesk.com/company/customers-partners/terms-of-use/</a>.

                  <br /><br />

                  We also encourage you to review:
                  <br /><br />

                  - Zendesk cookie policy: <a href="https://www.zendesk.com/company/policies-procedures/cookie-policy/">https://www.zendesk .com/company/policies-procedures/cookie-policy/</a>
                  <br />
                  - Zendesk Privacy and Data Protection: <a href="https://www.zendesk.com/company/privacy-and-data-protection/">https://www.zendesk
                  .com/company/privacy-and-data-protection/</a> <br />

                  - Other Zendesk Policies and Procedures listed at: <a href="https://www.zendesk.com/company/policies-procedures/">https://www.zendesk.com/company/policies-procedures/</a>

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>15. CI/CD tools</u></h2>
                  We may use third-party Service Providers to automate the development process of our Service.
                  <br/><br/>
                  <h3><strong>GitHub</strong></h3>
                  GitHub is provided by GitHub, Inc.
                  <br/><br/>
                  GitHub is a development platform to host and review code, manage projects, and build software.
                  <br/><br/>
                  For more information on what data GitHub collects, for what purpose, and how the protection of the
                  data is ensured, please visit GitHub Privacy Policy page: <a href="https://help.github.com/en/articles/github-privacy-statement">https://help.github.com/en/articles/github-privacy-statement</a>.

                  <br/><br/>
                  <h3><strong>GitLab CI/CD</strong></h3>
                  GitLab CI/CD is provided by GitLab, Inc.
                  <br/><br/>
                  GitLab CI (Continuous Integration) service is a part of GitLab that build and test the software whenever developer pushes code to application.
                  <br/><br/>
                  GitLab CD (Continuous Deployment) is a software service that places the changes of every code in the production which results in every day deployment of production.
                  <br/><br/>
                  For more information on what data GitLab CI/CD collects for what purpose and how the protection of the data is ensured, please visit GitLab CI/CD Privacy Policy page: <a href="https://about.gitlab.com/privacy/">https://about.gitlab.com/privacy/</a>.
                  <br/><br/>
                  <h3><strong>Travis CI</strong></h3>
                  Travis CI is a distributed continuous integration service to build and test projects hosted at GitHub.
                  <br/><br/>
                  For more information on what data Travis CI collects for what purpose and how the protection of the data is ensured, please visit Travis CI Privacy Policy page: <a href="https://docs.travis-ci.com/legal/privacy-policy">https://docs.travis-ci.com/legal/privacy-policy</a>.
                  <br/><br/>
                  <h3><strong>CircleCI</strong></h3>
                  CircleCI is provided by Circle Internet Services, Inc.
                  <br/><br/>
                  CircleCI is Continuous Integration, a development practice which is being used by software teams allowing them to build, test and deploy applications easier and quicker on multiple platforms.
                  <br/><br/>
                  For more information on what data Circle CI collects for what purpose and how the protection of the data is ensured, please visit Circle CI Privacy Policy page: <a href="https://circleci.com/privacy/">https://circleci.com/privacy/</a>.

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>16. Advertising</u></h2>
                  We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.
                  <br/><br/>
                  <h3><strong>Google AdSense DoubleClick Cookie</strong></h3>
                  Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.
                  <br/><br/>
                  You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: <a href="http://www.google.com/ads/preferences/">http://www.google.com/ads/preferences/</a>
                  <br/><br/>

                  <h3><strong>Bing Ads</strong></h3>
                  Bing Ads is an advertising service provided by Microsoft Inc.
                  <br/><br/>
                  You can opt-out from Bing Ads by following the instructions on Bing Ads Opt-out page: <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads">https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads</a>
                  <br/><br/>
                  For more information about Bing Ads, please visit their Privacy Policy: <a href="https://privacy.microsoft.com/en-us/PrivacyStatement">https://privacy.microsoft.com/en-us/PrivacyStatement</a>
                  <br/><br/>
                  <h3><strong>AdMob by Google</strong></h3>
                  AdMob by Google is provided by Google Inc.
                  <br/><br/>
                  You can opt-out from the AdMob by Google service by following the instructions described by Google:  <a href="https://support.google.com/ads/answer/2662922?hl=en">https://support.google.com/ads/answer/2662922?hl=en</a>
                  <br/><br/>
                  For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners' sites or app” page: <a href="http://www.google.com/policies/privacy/partners/">http://www.google.com/policies/privacy/partners/</a> or visit the Privacy Policy of Google: <a href="http://www.google.com/policies/privacy/">http://www.google.com/policies/privacy/</a>

                  <br/><br/>
                  <h3><strong>AdButler</strong></h3>
                  AdButler is an advertising service provided by Sparklit Networks Inc.
                  <br/><br/>
                  For more information about AdButler, please visit their Privacy Policy: <a href="https://www.sparklit.com/agreements.spark?agreement=privacy">https://www.sparklit.com/agreements.spark?agreement=privacy</a>

                  <br/><br/>
                  <h3><strong>Unity Ads</strong></h3>
                  Unity Ads is provided by Unity Technologies.
                  <br/><br/>
                  You can opt-out from Unity Ads service by following the instructions as described by Unity Technologies on their Privacy Policy page: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>

                  For more information about Unity Technologies, please visit Unity Technologies Privacy Policy: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>



              </div>

              <div class='tos'>
                  <h2 class='heading'><u>17. Behavioral Remarketing</u></h2>
                  Criminull Inc. uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.
                  <br/><br/>
                  <h3><strong>Google Ads (AdWords)</strong></h3>
                  Google Ads (AdWords) remarketing service is provided by Google Inc.
                  <br/><br/>
                  You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a>
                  <br/><br/>
                  Google also recommends installing the Google Analytics Opt-out Browser Add-on – <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a> – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
                  <br/><br/>
                  For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>18. Behavioral Payments</u></h2>
                  We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).
                  <br/><br/>
                  We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
                  <br/><br/>
                  The payment processors we work with are:
                  <br/><br/>
                  <h3><strong>Stripe:</strong></h3>
                  Their Privacy Policy can be viewed at: <a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a>

              </div>


              <div class='tos'>
                  <h2 class='heading'><u>19. Links to Other Sites</u></h2>
                  Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
                  <br/><br/>
                  We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>20. Children's Privacy</u></h2>
                  Our Services are not intended for use by children under the age of 18 (“<strong>Child</strong>” or “<strong>Children</strong>”).
                  <br/><br/>
                  We do not knowingly collect personally identifiable information from Children under 18. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>21. Changes to This Privacy Policy</u></h2>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                  <br/><br/>

                  We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.
                  <br/><br/>

                  You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.

              </div>

              <div class='tos'>
                  <h2 class='heading'><u>22. Contact Us</u></h2>
                  If you have any questions about this Privacy Policy, please contact us:
                  <br/><br/>
                  By email: <a href="mailto:hi@naminus.com" target="_top">hi@naminus.com</a>.

              </div>
          </div>
      </div>
    </div>
  </main>
</template>

<script>
  import States from "../../States"
  import {mapActions} from "vuex";

  export default {
      name: 'PrivacyView',
      mounted() {
          this.pageLoaded(this.$route);
      },

      methods:  {
          ...mapActions(['pageLoaded'])
      }
  }
</script>
